import type { DTOAbstractLoginRequest } from 'src/apis/dto/DTOAbstractLoginRequest';
import { Platform } from 'src/types/Platform';
import getDeviceId from 'src/utils/device/id';
import DeviceInfo, { getWebBrowserOs, getWebDisplayMode } from 'src/utils/device/info';
import { getClientSideCountryCode, getServerSideLanguageCode } from 'src/utils/language';

export function getLoginParam(
  { cancelDeletionReservation } = {
    cancelDeletionReservation: false,
  }
) {
  const deviceInfo = DeviceInfo();
  const model = `${deviceInfo.browserName}/${deviceInfo.browserVersion}/${deviceInfo.os}/${deviceInfo.osVersion}`;
  const flavor = deviceInfo.isMobile ? 'mobile' : 'desktop';

  return {
    localeInfo: {
      languageCode: getServerSideLanguageCode(),
      countryCode: getClientSideCountryCode(),
    },
    deviceId: getDeviceId(),
    timeZoneId: Intl?.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
    versionCode: 9999,
    background: false,
    clientProperties: {
      platform: Platform.WebClient,
      apiLevel: 9999,
      model,
      flavor,
      numOfCores: navigator.hardwareConcurrency ?? 1,
      webDisplayMode: getWebDisplayMode(),
      webBrowserOs: getWebBrowserOs(),
    },
    clientSideUserSettings: {
      browserLanguages: [...navigator.languages],
    },
    cancelDeletionReservation,
  } satisfies DTOAbstractLoginRequest;
}
